import { AgGridReact } from 'ag-grid-react';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { API_DOMAIN } from '../../EnvVars';
import { userIsAdmin } from '../../utils/RolesBasedUsers';
import './Dealers.css';
import * as featureNames from '../../utils/FeatureNames';
import TickIcon from '../Icons/TickIcon';
import UntickIcon from '../Icons/UntickIcon';
import { renderToString } from 'react-dom/server';
import Api from '../../api/api';

let colFeatures = [];

class dealerTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowSelection: 'single',
      enableFilter: true,
      enableSorting: true,
      enableColResize: true,
      loading: true,
      columnDefs: [],
      rowData: [],
      dealer: null,
      features: [],
      authToken: localStorage.getItem('authToken'),
    };

    // setup columns
    const columns = [];
    columns.push({
      headerName: 'Dealer (#)',
      field: 'dealer',
      pinned: 'left',
      valueGetter: function dealerPlusCode(params) {
        return `${params.data.dealer} (${params.data.dealerCode})`;
      },
    });
    columns.push({
      headerName: 'Location (#) | Location Name |  Display Suburb',
      field: 'locationName',
      pinned: 'left',
      valueGetter: function locPlusNumber(params) {
        return `${params.data.locationName} (${params.data.locationCode}) | ${
          params.data.locationNameOverride
        } | ${params.data.displaySuburb}`;
      },
    });
    columns.push({
      headerName: 'DMS',
      field: 'dmsName',
      pinned: 'left',
    });
    columns.push({
      headerName: 'Site ID',
      field: 'serviceSiteId',
      pinned: 'left',
    });

    colFeatures = data => {
      data.map(feature =>
        columns.push({
          headerName: feature.displayName,
          field: feature.feature,
          width: 48,
          value: feature.value,
          cellRenderer: params => {
            if (params.value === true) return renderToString(<TickIcon />);
            return renderToString(<UntickIcon />);
          },
        }),
      );
    };

    // get features for columns
    Api.getAllFeatures()
      .then(res => {
        this.setState({ loading: false });

        // Add features from dealer props
        res.push({
          feature: 'isPartsDealer',
          displayName: 'Part Dealer',
          description: 'Part Dealer',
          value: true,
        });
        res.push({
          feature: 'isTpoStripeConnectIdAvailable',
          displayName: 'Part stripe ID',
          description: 'TPO Stripe Connect ID',
          value: true,
        });
        res.push({
          feature: 'isOsbConnectIdAvailable',
          displayName: 'Service Stripe ID',
          description: 'OSB Stripe Connect ID',
          value: true,
        });
        colFeatures(res);
        this.setState({ columnDefs: columns });
      })
      .catch(error => {
        console.error(error);
        localStorage.setItem('httpOther', error.message);
        this.props.history.push({
          pathname: '/login',
        });
      });
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      localStorage.setItem('httpOther', 'Unauthorised or Session Expired');

      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // get dealer features
    Api.getDealerFeature()
      .then(response => {
        createRow(response);
        this.exportToJsonFile(response);
      })
      .catch(error => {
        localStorage.setItem('httpOther', error.message);
        this.props.history.push({
          pathname: '/login',
        });
      });

    // create row
    const createRow = data => {
      const rows = [];

      data.dealers.map(dealer => {
        dealer.locations.map(location => {
          // Set up data for the table
          const row = { features: [] };
          row.dealer = dealer.dealerName;
          row.dealerCode = dealer.dealerCode;
          row.dmsName = dealer.dms;
          row.locationName = location.locationName;
          row.leadTimeInDays = location.leadTimeInDays;
          row.locationNameOverride = location.locationNameOverride;
          row.locationCode = location.locationCode;
          row.locationAddress = location.locationAddress;
          row.suburb = location.suburb;
          row.displaySuburb = location.displaySuburb;
          row.state = location.state;
          row.postCode = location.postCode;
          row.serviceSiteId = location.serviceSiteId;
          location.features.map(feature => {
            row.features.push(feature);

            // duplicated data to placate agrigrid data format requirements of everything being on the same level
            row[feature.feature] = feature.value;
          });
          row.tpoStripeIdPresent = !!location.tpoStripeIdPresent;
          row.osbStripeIdPresent = !!location.osbStripeIdPresent;
          row.PART_DEALER = !!location.PART_DEALER;

          // Add all remaining data from api to be used elsewhere
          const _row = { ...location, ...row };

          rows.push(_row);
        });
      });

      this.setState({ rowData: rows });
      this.autoSizeAll();
    };
  }

  autoSizeAll = () => {
    const allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(column => {
      if (
        column.colId === 'dealer' ||
        column.colId === 'locationName' ||
        column.colId === 'dmsName' ||
        column.colId === 'serviceSiteId'
      ) {
        allColumnIds.push(column.colId);
      }
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  };

  onSelectionChanged = params => {
    this.gridApi = params.api;
    const selectedRows = this.gridApi.getSelectedRows();
    const selected_row = selectedRows[0];

    const dealer = this.state.rowData.filter(
      dealer => dealer.locationCode === selected_row.locationCode,
    )[0];

    if (dealer) {
      this.setState({ dealer: dealer });
      this.props.history.push({
        pathname: '/editdealer',
        state: { dealer: dealer },
      });
    }
  };

  exportToCSV = () => {
    const rows = [];

    const row = this.state.rowData[0];
    const arr = [];
    for (const col in row) {
      const spacedColName = insertSpaces(col);

      const result = spacedColName.toLowerCase().replace(/([A-Z])/g, ' $1');
      arr.push(result.charAt(0).toUpperCase() + result.slice(1));
    }
    rows.push(arr);

    this.state.rowData.map(row => {
      const arr = [];
      for (const col in row) {
        arr.push(row[col]);
      }
      rows.push(arr);
    });

    let csvContent = 'data:text/csv;charset=utf-8,' + rows.map(e => e.join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Dealer.csv');
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);

    function insertSpaces(word) {
      let _word = word;
      while (_word.indexOf('_') > -1) {
        _word = _word.replace('_', ' ');
      }

      // convert camel case to sentence case if word is not all caps (lazy check)
      if (!isUpperCase(_word[0]) && !isUpperCase(_word[1])) {
        return _word
          .replace(/([A-Z])/g, match => ` ${match}`)
          .replace(/^./, match => match.toUpperCase());
      }

      return _word;

      function isUpperCase(char) {
        return char >= 'A' && char <= 'Z';
      }
    }
  };

  exportToJsonFile = data => {
    const dataStr = JSON.stringify(data, null, 2);
    const dataUri = `data:application/json;charset=utf-8,${encodeURIComponent(dataStr)}`;
    const exportFileDefaultName = 'Dealer.json';
    this.setState({ dataUri, exportFileDefaultName });
  };

  render() {
    const {
      loading,
      rowSelection,
      enableFilter,
      enableSorting,
      enableColResize,
      columnDefs,
      rowData,
      dataUri,
      exportFileDefaultName,
    } = this.state;
    return (
      <div className="dealerTableWrapper">
        <div id="dealerTable" className="ag-theme-balham">
          <AgGridReact
            rowSelection={rowSelection}
            enableFilter={enableFilter}
            enableSorting={enableSorting}
            enableColResize={enableColResize}
            columnDefs={columnDefs}
            rowData={rowData}
            onSelectionChanged={this.onSelectionChanged.bind(this)}
            onGridReady={this.onGridReady.bind(this)}
            overlayNoRowsTemplate={loading ? 'Fetching data...' : 'No information to display'}
            headerHeight="160"
            resizable="true"
            autoHeight="true"
          />
        </div>
        <div>
          <br />
          <span className="glyphicon glyphicon-remove featureoff" />
          <span> This feature is disabled, however it can be toggled at the location level.</span>
        </div>
        <br />
        <br />
        <button className={`btn btn-primary dealerEditSaveButton`}>
          <a className="buttonLink" href={dataUri} download={exportFileDefaultName}>
            Download as JSON
          </a>
        </button>
        <button className={`btn btn-primary dealerEditSaveButton`} onClick={this.exportToCSV}>
          Export to CSV
        </button>
      </div>
    );
  }
}

export default withRouter(dealerTable);



// WEBPACK FOOTER //
// ./src/components/Dealers/DealerTable.js